<template>
  <div v-if="listSites.length > 0">
    <v-col cols="12">
      <v-select
        :items="listSites"
        :item-text="(obj) => obj.code"
        :item-value="(obj) => obj.code + ' - ' + obj.gmc_merchant_id"
        dense
        outlined
        v-model="siteSelected"
        label="Select Store"
        @change="loadGMCData"
      ></v-select>

      <v-alert type="error" v-if="informText != ''">
        {{ informText }}
      </v-alert>

      <template v-if="!loading">
        <template v-if="gmcData.account_issues">
          <v-tabs v-model="tab" background-color="info" dark>
            <v-tab> Item Issues </v-tab>
            <v-tab>
              Account Issues ({{ gmcData.account_issues.length }})
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card><GMCItemIssue :gmcData="gmcData" /></v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card><GMCAccIssue :gmcData="gmcData" /></v-card>
            </v-tab-item>
          </v-tabs-items>
        </template>
      </template>
      <div v-else>
        <img v-bind:src="require('../../assets/loading/loading.gif')" />
      </div>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";
import GMCAccIssue from "./c-gmc-account-issue.vue";
import GMCItemIssue from "./c-gmc-item-issue.vue";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "GMCContainer",

  components: { GMCAccIssue, GMCItemIssue },

  data: () => ({
    loading: false,
    tab: null,
    listSites: [],
    siteSelected: [],
    informText: "",
    gmcData: {},
    roles: [],
  }),

  methods: {
    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "gmc-site"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "sites?platform=Shopify", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);

            for (var i of response.data.data) {
              if (i.gmc_merchant_id != "") {
                console.log(i.code);
                this.listSites.push(i);
              }
            }

            console.log("listSites: ", this.listSites);
          });
      } else {
        console.log("accessToken gmc-site undefined");
      }
    },

    async loadGMCData() {
      this.informText = "";
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "gmc-data"
      );
      if (currentSession.accessToken) {
        await axios
          .get(
            window.domain +
              "gmc/account-statuses/" +
              this.siteSelected.split(" - ")[1],
            {
              headers: { Authorization: currentSession.accessToken },
            }
          )
          .then((response) => {
            console.log("response: ", response);
            if (response.data.error_message == "") {
              this.gmcData = response.data.data;
            } else {
              this.informText = response.data.error_message;
              this.gmcData = {};
            }
            this.loading = false;
          });
      } else {
        console.log("accessToken gmc-data undefined");
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("gmc");
    if (this.roles.read_account_statuses) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>